import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
    GET_SINGLE_PROMOTIONS,
    ACTIVATE_PROMOTION,
    DEACTIVATE_PROMOTION,
} from '../endPoints';
import { headers } from '../baseUrl/setHeaders';
import { baseURL } from '../baseUrl/baseURL';

export const promotionAPI = createApi({
    reducerPath: 'promotionAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: baseURL,
        prepareHeaders: headers,
    }),
    endpoints: (builder) => ({
        getSinglePromotion: builder.query({
            query: (id) => `${GET_SINGLE_PROMOTIONS}${id}`,
        }),
        activatePromotion: builder.mutation({
            query: (id) => ({
                url: `${ACTIVATE_PROMOTION}${id}`,
                method: 'POST',
                body: [],
            }),
        }),
        deactivatePromotion: builder.mutation({
            query: (id) => ({
                url: `${DEACTIVATE_PROMOTION}${id}`,
                method: 'POST',
                body: [],
            }),
        }),
    }),
});

export const {
    useGetSinglePromotionQuery,
    useActivatePromotionMutation,
    useDeactivatePromotionMutation,
} = promotionAPI;
